module.exports = __webpack_public_path__ + "img/REWARD02.280e6ff5.png";